import axios from "axios";
import Config from "../../../config";

const v2_actionCrmPesquisarLeads = (querys) => {
    
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/leads/pesquisar${querys ? querys : ''}`
    });
};

export default v2_actionCrmPesquisarLeads;
